'use client'

import Script from 'next/script'

const PageHero = () => {
    return (
        <>
            <div
                data-type="background"
                data-speed=".5"
                className="h-[200px] bg-[#232f5f] bg-cover bg-center bg-fixed bg-no-repeat"
                style={{
                    backgroundImage: "url('/images/page_billboard_image.jpg')",
                }}
            ></div>
            <Script id="page-hero-parallax-script">
                {`
                    const bg = document.querySelector('[data-type="background"]');
                    const speed = bg.getAttribute("data-speed");
                    window.addEventListener("scroll", function() {
                        const offset = window.pageYOffset;
                        bg.style.backgroundPositionY = offset * speed + "px";
                    });
                `}
            </Script>
        </>
    )
}

export default PageHero
